export default __webpack_public_path__ + "static/media/firstvid.9679a693.mp4";